import { Controller } from "@hotwired/stimulus"
import IMask from "imask"
// Connects to data-controller="form--phone"
export default class extends Controller {

  connect() {
    IMask(this.element, {
      mask: '(+{33})0 00 00 00 00'
    })
  }
}
